var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab.route,attrs:{"to":{ name: tab.route },"replace":""}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }